/* The Pull Society: Add to basket on homepage tiles without leaving the page. Falls back to a normal form post. */
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[data-tpc-quick-add]');
  if (!form || !window.fetch) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const label = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';
  try {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    if (!response.ok) throw new Error((await response.json()).description || 'Could not add');
    const link = document.createElement('a');
    link.href = (window.Shopify?.routes?.root || '/') + 'cart';
    link.className = button.className;
    link.textContent = 'Added ✓ View basket';
    button.replaceWith(link);
    document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(async (el) => {
      const cart = await (await fetch('/cart.js')).json();
      el.textContent = cart.item_count;
    });
  } catch (error) {
    button.disabled = false;
    button.textContent = error.message && error.message.length < 40 ? error.message : 'Try again';
    setTimeout(() => { button.textContent = label; }, 2500);
  }
});
